export default __webpack_public_path__ + "static/Marlucia-7b7e1b95aee378bf602af35e13a18c99.png";